import { render, staticRenderFns } from "./SetProduct.vue?vue&type=template&id=bdfb355e"
import script from "./SetProduct.vue?vue&type=script&lang=js"
export * from "./SetProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports